import ScrollAnimation from 'core/ScrollAnimation';
import { sanitize } from 'isomorphic-dompurify';

import { DescriptionType } from '~/components/features/cases/NextComponents/cases-sections/TitleCase';

import cn from './style.module.sass';

type TitleCaseMiddleProps = {
    descriptions: DescriptionType[];
};

export default function TitleCaseMiddle({ descriptions }: TitleCaseMiddleProps) {
    return (
        <ScrollAnimation className={cn.contentCaseMiddle}>
            <div className={cn['contentCaseMiddle__wrapper']}>
                {descriptions.map(item => (
                    <div key={item.name} className={cn['contentCaseMiddle__item']}>
                        <div
                            dangerouslySetInnerHTML={{ __html: sanitize(item.name) }}
                            className={cn['contentCaseMiddle__wrapper-name']}
                        />
                        <div
                            dangerouslySetInnerHTML={{ __html: sanitize(item.details) }}
                            className={cn['contentCaseMiddle__wrapper-details']}
                        />
                    </div>
                ))}
            </div>
        </ScrollAnimation>
    );
}
